import { render, staticRenderFns } from "./CreateProviderAdditionalFee.vue?vue&type=template&id=9ba23d3e"
import script from "./CreateProviderAdditionalFee.vue?vue&type=script&lang=js"
export * from "./CreateProviderAdditionalFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports